module.exports = __webpack_public_path__ + "public/img/Mengembangkan Konten di Media Sosial Untuk Menjadi Spesialis Pemasaran Digital.d513f0ae.png";